var _defs, _path, _circle, _polyline, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMod3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 837.44 674.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#2731b8;stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:20px;}.cls-2,.cls-3{stroke-linecap:round;}.cls-3{stroke-width:11px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M568,839.58C550.12,672,661.29,548.6,751.9,546.1c92.69-2.56,213.81,120,198,293.48Z",
    transform: "translate(-123.83 -175.55)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 631.22,
    cy: 228.94,
    r: 141.56
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "500.94 447.88 10 447.88 10 10 766.35 10 766.35 186.63"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 766.35,
    y1: 271.25,
    x2: 766.35,
    y2: 447.89
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 574.29,
    y1: 515.98,
    x2: 216.23,
    y2: 203.15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.49,
    y1: 87.38,
    x2: 506.29,
    y2: 87.38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.49,
    y1: 148.37,
    x2: 442.29,
    y2: 148.37
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.49,
    y1: 209.37,
    x2: 347.79,
    y2: 209.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMod3);
export default __webpack_public_path__ + "static/media/Mod3.65102804393699ae9da8f71c6d70e691.svg";
export { ForwardRef as ReactComponent };